import React, { FC } from 'react';
import { Switch } from '../switch/switch';
import { NumberInput } from '../number-input/number-input';
import { CancelButton } from '../cancel-button/cancel-button';
import { PrintedPageData } from '../../../types';
import { MAX_COLOR_COUNT } from '../../../constants';
import './container-row.css';

interface Props {
  name: string,
  index: number,
  onDelete: (index: number) => void;
  isDeletable: boolean;
  setColorCount: (index: number, count: number) => void;
  onBackside: (index: number) => void;
  printedPage: PrintedPageData;
}

export const ContainerRow: FC<Props> = ({
  name,
  index,
  onDelete,
  isDeletable = false,
  setColorCount,
  onBackside,
  printedPage,
}) => {
  const onColorCount = (value: number) => {
    setColorCount(index, value);
  };
  const toggleBackside = (e: React.FormEvent<HTMLInputElement>) => {
    onBackside(index);
  };

  return (
    <div className="container-row">
      <span>{name}</span>
      <NumberInput
        onChange={onColorCount}
        value={printedPage.colorCount}
        max={MAX_COLOR_COUNT}
      />
      <Switch
        onChange={toggleBackside}
        checked={!!printedPage.backSide}
      />
      {isDeletable && (
        <span className="delete-btn-wrapper">
          <CancelButton onCancel={() => onDelete(index)} alignToTop={false} />
        </span>
      )}
    </div>
  );
};